module.exports = "/_next/static/images/shiyan-8745da94612d56c348636b6975a7cda4.jpg";